export default {
    DOWNLOAD_MEDIA_REQUEST: 'DOWNLOAD_MEDIA##REQUEST',
    DOWNLOAD_MEDIA_SUCCESS: 'DOWNLOAD_MEDIA##SUCCESS',
    CREATE_MEDIA_REQUEST: 'CREATE_MEDIA##REQUEST',
    CREATE_MEDIA_SUCCESS: 'CREATE_MEDIA##SUCCESS',
    UPDATE_MEDIA_REQUEST: 'UPDATE_MEDIA##REQUEST',
    UPDATE_MEDIA_SUCCESS: 'UPDATE_MEDIA##SUCCESS',
    FETCH_MEDIA_REQUEST: 'FETCH_MEDIA##REQUEST',
    FETCH_MEDIA_SUCCESS: 'FETCH_MEDIA##SUCCESS',
    FETCH_SINGLE_MEDIA_REQUEST: 'FETCH_SINGLE_MEDIA##REQUEST',
    FETCH_SINGLE_MEDIA_SUCCESS: 'FETCH_SINGLE_MEDIA##SUCCESS',
    FETCH_MEDIA_DETAILS_REQUEST: 'FETCH_MEDIA_DETAILS##REQUEST',
    FETCH_MEDIA_DETAILS_SUCCESS: 'FETCH_MEDIA_DETAILS##SUCCESS',
    FETCH_MEDIA_DETAILS_FAILURE: 'FETCH_MEDIA_DETAILS##FAILURE',
    API_CALL_FAILURE: 'API_CALL##FAILURE',
    UPLOAD_MEDIA_REQUEST: 'UPLOAD_MEDIA##REQUEST',
    UPLOAD_MEDIA_SUCCESS: 'UPLOAD_MEDIA##SUCCESS',
    DOWNLOAD_MEDIA_THUMBNAIL_REQUEST: ' DOWNLOAD_MEDIA_THUMBNAIL##REQUEST',
    DOWNLOAD_MEDIA_THUMBNAIL_SUCCESS: 'DOWNLOAD_MEDIA_THUMBNAIL##SUCCESS',
    DOWNLOAD_MEDIA_THUMBNAIL_FAIL: 'DOWNLOAD_MEDIA_THUMBNAIL##FAIL',
    DELETE_MEDIA_REQUEST: 'DELETE_MEDIA#REQUEST',
    DELETE_MEDIA_SUCCESS: 'DELETE_MEDIA#SUCCESS',
    CHANGE_MEDIA: 'CHANGE_MEDIA',
    RETRY_UPLOAD_MEDIA_REQUEST: 'RETRY_UPLOAD_MEDIA##REQUEST',
    RETRY_UPLOAD_MEDIA_SUCCESS: 'RETRY_UPLOAD_MEDIA##SUCCESS',
    UPLOAD_COMPLETED_MEDIA_REQUEST: 'UPLOAD_COMPLETED_MEDIA##REQUEST',
    UPLOAD_COMPLETED_MEDIA_SUCCESS: 'UPLOAD_COMPLETED_MEDIA##SUCCESS',
    APPROVE_MEDIA_REQUEST: 'APPROVE_MEDIA##REQUEST',
    APPROVE_MEDIA_SUCCESS: 'APPROVE_MEDIA##SUCCESS',
    APPROVE_MEDIA_FAILURE: 'APPROVE_MEDIA##FAILURE',
    TEST_MEDIA_REQUEST: 'TEST_MEDIA##REQUEST',
    TEST_MEDIA_SUCCESS: 'TEST_MEDIA##SUCCESS',
    TEST_MEDIA_FAILURE: 'TEST_MEDIA##FAILURE',
    APPROVAL_REQUEST_MEDIA_REQUEST: 'APPROVAL_REQUEST_MEDIA##REQUEST',
    APPROVAL_REQUEST_MEDIA_SUCCESS: 'APPROVAL_REQUEST_MEDIA##SUCCESS',
    APPROVAL_REQUEST_MEDIA_FAILURE: 'APPROVAL_REQUEST_MEDIA##FAILURE',
    MEDIA_PUSH_STATUS_REQUEST: 'MEDIA_PUSH_STATUS##REQUEST',
    MEDIA_PUSH_STATUS_SUCCESS: 'MEDIA_PUSH_STATUS##SUCCESS',
    MEDIA_PUSH_STATUS_FAILURE: 'MEDIA_PUSH_STATUS##FAILURE',
    ATTACH_MEDIA_PLAYLIST_REQUEST: 'ATTACH_MEDIA_PLAYLIST##REQUEST',
    ATTACH_MEDIA_PLAYLIST_SUCCESS: 'ATTACH_MEDIA_PLAYLIST##SUCCESS',
    ATTACH_MEDIA_PLAYLIST_FAILURE: 'ATTACH_MEDIA_PLAYLIST##FAILURE',
    DETACH_MEDIA_PLAYLIST_REQUEST: 'DETACH_MEDIA_PLAYLIST##REQUEST',
    DETACH_MEDIA_PLAYLIST_SUCCESS: 'DETACH_MEDIA_PLAYLIST##SUCCESS',
    DETACH_MEDIA_PLAYLIST_FAILURE: 'DETACH_MEDIA_PLAYLIST##FAILURE',
    FETCH_MEDIA_PENDING_APPROVAL_COUNT_REQUEST: 'FETCH_MEDIA_PENDING_APPROVAL_COUNT##REQUEST',
    FETCH_MEDIA_PENDING_APPROVAL_COUNT_SUCCESS: 'FETCH_MEDIA_PENDING_APPROVAL_COUNT##SUCCESS',
    FETCH_MEDIA_PENDING_APPROVAL_COUNT_FAILURE: 'FETCH_MEDIA_PENDING_APPROVAL_COUNT##FAILURE',
    FETCH_MEDIA_PENDING_PUSH_COUNT_REQUEST: 'FETCH_MEDIA_PENDING_PUSH_COUNT##REQUEST',
    FETCH_MEDIA_PENDING_PUSH_COUNT_SUCCESS: 'FETCH_MEDIA_PENDING_PUSH_COUNT##SUCCESS',
    FETCH_MEDIA_PENDING_PUSH_COUNT_FAILURE: 'FETCH_MEDIA_PENDING_PUSH_COUNT##FAILURE',
    FETCH_MEDIA_PENDING_TEST_COUNT_REQUEST: 'FETCH_MEDIA_PENDING_TEST_COUNT##REQUEST',
    FETCH_MEDIA_PENDING_TEST_COUNT_SUCCESS: 'FETCH_MEDIA_PENDING_TEST_COUNT##SUCCESS',
    FETCH_MEDIA_PENDING_TEST_COUNT_FAILURE: 'FETCH_MEDIA_PENDING_TEST_COUNT##FAILURE',
}
